import currencyFormatting from '@package/utils/src/currencyFormatting';
import { IsoCountryName } from '@package/utils/src/types/IsoCountryName';

import ProductFee from '../ProductCard/__components/ProductFee';
import SummaryItem from '../SummaryItem';

import { SummaryItemsProps } from './types';

const SummaryItemsList = ({ summary }: SummaryItemsProps) => {
  return (
    <>
      <SummaryItem
        id="products-and-services"
        isVisible={Boolean(summary.productsAndServices)}
        title={'Products & Services'}
        price={currencyFormatting(summary.productsAndServices, false)}
      />

      {summary.additionalProductFees &&
        summary.additionalProductFees.map((productFee: any) => (
          <SummaryItem
            key={`summary-${productFee?.name}`}
            id="product-fee"
            isVisible={Boolean(productFee.price)}
            title={<ProductFee data={productFee} />}
            price={currencyFormatting(productFee.price, false)}
          />
        ))}

      <SummaryItem
        id="coupon-discount"
        isVisible={Boolean(summary.couponDiscount)}
        title={'Coupon Discount'}
        price={summary.couponDiscount && `-${currencyFormatting(summary.couponDiscount, false)}`}
      />

      <SummaryItem
        id="auto-apply-coupon"
        isVisible={Boolean(summary.autoApplyCouponResponse?.autoCouponDiscount)}
        title={summary.autoApplyCouponResponse?.couponNumber}
        price={
          summary.autoApplyCouponResponse?.autoCouponDiscount &&
          `-${currencyFormatting(summary.autoApplyCouponResponse?.autoCouponDiscount, false)}`
        }
      />

      <SummaryItem
        id="gift-card-payments"
        isVisible={Boolean(summary.giftCard)}
        title={'Gift Card Payments'}
        price={summary.giftCard && `-${currencyFormatting(summary.giftCard, false)}`}
      />

      <SummaryItem
        id="bundle-discount"
        isVisible={Boolean(summary.bundleDiscount)}
        title={'Bundle Discount'}
        price={summary.bundleDiscount && `-${currencyFormatting(summary.bundleDiscount, false)}`}
      />

      <SummaryItem
        id="sales-tax"
        isVisible={Boolean(summary.tax)}
        title={
          summary?.country === IsoCountryName.Canada
            ? 'Handling fee'
            : `${summary?.state && summary?.state !== null ? `${summary.state} Sales Tax` : 'Sales Tax'}`
        }
        price={currencyFormatting(summary.tax, false)}
      />

      <SummaryItem
        id="bullseye-bucks-discount"
        isVisible={Boolean(summary.bullseyeBucks)}
        title={'Bullseye Bucks'}
        price={summary.bullseyeBucks && `-${currencyFormatting(summary.bullseyeBucks, false)}`}
      />

      <SummaryItem
        id="cart-summary-checkout-subtotal"
        isVisible={Boolean(summary.subTotal)}
        title={`${'Subtotal'} (USD)`}
        price={currencyFormatting(summary.subTotal, false)}
      />
    </>
  );
};

export default SummaryItemsList;
